import { motion } from 'motion/react';

import classes from './AtlasAiHero.module.css';
import { AtlasAiTitle } from './AtlasAiTitle.tsx';
import { agentTransition } from './transitions.ts';
import { AtlasAiSpinner } from '#plugin-chat/components/hero/AtlasAiSpinner.tsx';

const defaultChildren = <AtlasAiTitle />;

/** Animated hero section for Atlas AI chat interface with video spinner and customizable content. */
export function AtlasAiHero({ children = defaultChildren }: React.PropsWithChildren) {
  return (
    <motion.div animate="show" className={classes.hero} exit="exit" initial="hidden" layout>
      <motion.div className={classes.spinner} variants={agentTransition}>
        <AtlasAiSpinner />
      </motion.div>

      {children}
    </motion.div>
  );
}
